<template>
  <div>
    <van-grid column-num="3">
      <!-- <van-grid-item icon="gem-o" text="新增商户" url="/Merchant/add" /> -->

      <van-grid-item icon="point-gift-o" text="服务商登录" @click="agent"/>
      <van-grid-item icon="contact" text="商户登录"  @click="merchant"/>
      <van-grid-item icon="setting-o" text="个人设置" url="/SalesmanSetting"/>
      <van-grid-item icon="contact" text="业务员登录"  @click="linkto"/>


     <!-- <van-grid-item icon="point-gift-o" text="服务商登录" url="/AgentImpower" />
     <van-grid-item icon="contact" text="商户登录"  url="/MerchantImpower"/>
     <van-grid-item icon="setting-o" text="个人设置" url="/SalesmanSetting" />
     <van-grid-item icon="contact" text="业务员登录"  url="/SalesmanLogin"/> -->


     <!-- <van-grid-item icon="contact" text="门店登录"  @click="store" /> -->
      <!-- <van-grid-item icon="contact" text="门店登录"  url="/StoreImpower" /> -->
    </van-grid>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {}
  },
  mounted() {
    // if (!window.localStorage.getItem('openId')) { // 如果缓存localStorage中没有微信openId，则需用code去后台获取
    //   this.getCode()
    // } else {
    //   // 别的业务逻辑
    // }
  },
  methods: {
    linkto() {
      // console.log(111111111111111111111);
      // window.sessionStorage.setItem("tag", 'salesman_log');
      // const loged = window.localStorage.getItem("salesman_token");
      // console.log(loged);
      // if (loged) {
      //   this.$router.push("/SalesmanHome");
      // } else {
      var url = window.location.href
      window.location.href =
          'https://server.keyupay.com/wechat/login/authLogin.html?redirect=' +
          url +
          'SalesmanLogin'
      // this.$router.push("/SalesmanLogin");
      // }
    },
    store() {
      var url = window.location.href

      window.location.href =
        'https://server.keyupay.com/wechat/login/authLogin.html?redirect=' +
        url +
        'StoreImpower'
    },
    merchant() {
      var url = window.location.href
      window.location.href =
        'https://server.keyupay.com/wechat/login/authLogin.html?redirect=' +
        url +
        'MerchantImpower'
    },
    agent() {
      var url = window.location.href
      window.location.href =
        'https://server.keyupay.com/wechat/login/authLogin.html?redirect=' +
        url +
        'AgentImpower'
    }
    // getCode() { // 非静默授权，第一次有弹框
    //   this.code = ''
    //   var local = window.location.href // 获取页面url
    //   var appid = 'wx65adcf0753691319'
    //   this.code = this.getUrlCode().code // 截取code
    //   if (this.code == null || this.code === '') { // 如果没有code，则去请求
    //     window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
    //   } else {
    //     // 你自己的业务逻辑
    //   }
    // },
    // getUrlCode() { // 截取url中的code方法
    //   var url = location.search
    //   this.winUrl = url
    //   var theRequest = new Object()
    //   if (url.indexOf("?") != -1) {
    //     var str = url.substr(1)
    //     var strs = str.split("&")
    //     for (var i = 0; i < strs.length; i++) {
    //       theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1])
    //     }
    //   }
    //   return theRequest
    //
    // },
  }
}
</script>

<style scoped>
</style>
